import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { graphql } from 'react-apollo'
import ChecklistItems from './features/ChecklistItems'
import styled from 'styled-components'
import Commentary from './features/Commentary'
import Highlight from './features/Highlight'
import Loader from '../common/Loader'
import Error from '../common/Error'
import PriorityNotesQuery from './queries/PriorityNotesQuery'
import HelpfulHints from './features/HelpfulHints'

const TitleContainer = styled.div`
  height: 38px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 28px;
  font-weight: 600;
  line-height: 38px;
`

class PriorityNotes extends Component {
  renderChecklist = () => {
    const { isBankUser, data } = this.props
    const { loan = {} } = data
    if (!isBankUser && loan.checklistItems !== undefined) {
      return (
        <ChecklistItems loan={loan} isBankUser={isBankUser} />
      )
    }
  }

  renderHelpfulHints = () => {
    const { isBankUser, data } = this.props
    const { loan = {} } = data
    if (!isBankUser && loan.helpfulHints !== undefined) {
      return (
        <HelpfulHints loan={loan} isBankUser={isBankUser} />
      )
    }
  }

  renderCommentaries = () => {
    const { isBankUser, data, loanId, currentAdminId } = this.props
    const { loan = {} } = data
    if (isBankUser || loan.bankCommentaries.length > 0) {
      return (
        <Commentary
          loan={loan}
          loanId={loanId}
          currentAdminId={currentAdminId}
          isBankUser={isBankUser} />
      )
    }
  }

  renderHighlights = () => {
    const { isBankUser, data, loanId } = this.props
    const { loan = {} } = data
    if (loan.highlights.length > 0) {
      return (
        <Highlight
          loanId={loanId}
          isBankUser={isBankUser}
          loan={loan}
        />
      )
    }
  }

  render() {
    const { loading, error, loan } = this.props.data
    const container = document.getElementById('action_items')
    if (loading) {
      return <Loader number={4} />
    }
    if (error || loan == undefined) {
      return <Error />
    }
    return ReactDOM.createPortal(
      (
        <div>
          <TitleContainer>Highlights</TitleContainer>
          {this.renderChecklist()}
          {this.renderHelpfulHints()}
          {this.renderCommentaries()}
          {this.renderHighlights()}
        </div>
      ),
      container
    )
  }
}

export { PriorityNotes }

export default graphql(PriorityNotesQuery, {
  options: OwnProps => ({
    variables: {
      rid: parseInt(OwnProps.loanId, 10)
    }
  })
})(PriorityNotes)
